// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import trash01Icon from "@/assets/icons/trash-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Trash01IconProps = Omit<IconProps, "name">;

export function Trash01Icon(props: Trash01IconProps): React.ReactNode {
  return <Icon name={trash01Icon} {...props} />;
}
